import React, { useState } from "react";
import { ConfirmModal } from "../../../../../../../../../boxes/ConfirmModal/ConfirmModal";
import { useReleaseAppointmentHoldMutation } from "../../../../../../../../../api/appointments/useReleaseAppointmentHoldMutation";
import { uiNotification } from "../../../../../../../../../services/UINotificationService";
import { useContext } from "../../../context";

/*
 * A cancellation-policy hold has no deposit to cancel, so this is the only way
 * for the clinic to open the slot before the 30 minute timer. A deposit hold
 * never reaches this button.
 */
export function ReleaseAppointment() {
  const { id, onClose, refetchAppointments } = useContext();
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const { mutate, isLoading } = useReleaseAppointmentHoldMutation({
    onSuccess: () => {
      uiNotification.success(
        "Appointment released. The slot is open and the card link no longer works.",
      );
      setIsConfirmOpen(false);
      onClose();
      refetchAppointments();
    },
    onError: () => {
      uiNotification.error(
        "This hold can no longer be released. It may already be confirmed or it has a deposit.",
      );
      setIsConfirmOpen(false);
    },
  });

  return (
    <>
      <button
        className="new-red-btn"
        onClick={() => setIsConfirmOpen(true)}
        disabled={isLoading}
      >
        {isLoading ? "Releasing..." : "Release appointment"}
      </button>
      <ConfirmModal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirm={() => mutate({ appointmentId: id })}
        onCancel={() => setIsConfirmOpen(false)}
        title="Release appointment"
        confirmTitle="Release appointment"
        cancelTitle="Keep hold"
        isConfirming={isLoading}
      >
        The slot opens up now, and the patient&apos;s card link stops working.
      </ConfirmModal>
    </>
  );
}
